import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';

export namespace NICmsOutletBlockComponent {
    export const BLOCK_ID = 'icms-outlet-block-component';

    export interface IBlockDataContent {
        components: NICmsContentComponent.IData[];
    }
}

@Component({
    selector: 'icms-outlet-block',
    templateUrl: 'icms-outlet-block.html',
    styleUrls: ['icms-outlet-block.scss'],
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ICmsOutletBlockComponent>({
    id: NICmsOutletBlockComponent.BLOCK_ID,
    block: {
        url: NICmsOutletBlockComponent.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Outlet',
    description: 'Outlet block',
    fields: [
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'component',
            default: []
        }
    ]
})
export class ICmsOutletBlockComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NICmsOutletBlockComponent.IBlockDataContent;

    @Input({
        required: true
    })
    variant!: string;

    @Input({
        required: true
    })
    name!: string;

    /**
     * Components identifieres list, extends default components list by requested ones here even if they are on demand only
     */
    @Input()
    allow?: string[];

    /**
     * Components identifieres list, restricts the list to these components only
     */
    @Input()
    allowOnly?: string[];

    /**
     * Components identifieres list, disallows listed components
     */
    @Input()
    disallow?: string[];
}
